import './DatePickers.scss';
import { BOGOTA_TZ, getDayOfMonthBogota, isTodayBogota, parseDateOnlyBogota } from 'utils/dateTZ';

interface IHour {
  startHour: string;
  endHour: string;
}

interface IProps {
  date?: string;
  handleClick?: () => void;
  hour?: IHour[];
  isActive?: boolean;
  nameDay?: string;
  type: string;
}

export const DatePickers = (props: IProps) => {
  const { date, type, nameDay, handleClick, hour, isActive } = props;

  const getDayAndDate = (dateTime: string) => {
    const dateObject = parseDateOnlyBogota(dateTime);
    const formatter = new Intl.DateTimeFormat('es-ES', {
      weekday: 'short',
      day: 'numeric',
      timeZone: BOGOTA_TZ,
    });
    const parts = formatter.formatToParts(dateObject);
    const dayOfWeek = parts.find((p) => p.type === 'weekday')?.value ?? '';
    const dayOfMonth = getDayOfMonthBogota(dateTime);
    return { dayOfWeek, dayOfMonth };
  };

  const isToday = (dateTime: string) => isTodayBogota(dateTime);

  return (
    <div className='containerPicker'>
      {type === 'day' && date && (
        <button onClick={handleClick}>
          <div className={isActive ? 'picker picker__active' : 'picker'}>
            {isToday(date) && <p>Hoy</p>}
            <p className='picker__text'>{nameDay?.slice(0, 3)}</p>{' '}
            {/* Muestra el día de la semana */}
            <p className='picker__day'>{getDayAndDate(date).dayOfMonth}</p>{' '}
            {/* Muestra el número del día */}
          </div>
        </button>
      )}

      {type === 'hour' && hour && (
        // Renderiza Date Pickers de tipo 'hour' solo si hay un DatePicker activo
        <div className='hour-pickers'>
          <button onClick={handleClick}>
            <div
              className={isActive ? 'picker picker__hour picker__active' : 'picker picker__hour'}
            >
              {hour[0].startHour} - {hour[0].endHour}
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default DatePickers;
